import { CartItem } from '@/types/Cart'

export const countItem = (items: CartItem[], itemId: string) =>
    items.reduce(
        (prev, curr) =>
            curr.item.item_id === itemId ? prev + curr.count : prev,
        0
    )
